import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class EditProfile extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.editProfile, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
